import * as React from 'react';
import {IFormFields, SCOMP} from 'myshubhlife-component/form/FormInterfaceProps';
import InputField from 'myshubhlife-component/form/fields/InputTextField';
import Dropdown from 'myshubhlife-component/form/fields/Dropdown';
import RadioButton from 'myshubhlife-component/form/fields/RadioButton';
import DocUpload from 'myshubhlife-component/form/fields/DocUpload';
import OtpField from 'myshubhlife-component/form/fields/OtpField';
import DatePickerField from "myshubhlife-component/form/fields/DatePicker";

function FormGroup(groupfields: IFormFields) {
  
  const handleFormChange = (value: string | number | string[] | boolean,  index: number, identifier: string) => {
    groupfields.handleFormChange(index, value, groupfields.formindex, identifier)
  }
  return (
    <div>
    {groupfields.formfields.label && <h2 className="form-heading">{groupfields.formfields.label}</h2>}
    {
      groupfields.formfields.fields.map((field, index) => {
        switch (SCOMP[field['type'].toUpperCase()]) {
          case 'text':
            return (
              <InputField key={`${field.identifier}${index}`} styleType={groupfields.inputStyleType} field={field} index={index} handleFormChange={handleFormChange} />
            )
          case 'dropdown':
            return (
              <Dropdown key={`${field.identifier}${index}`} styleType={groupfields.selectStyleType} field={field} index={index} handleFormChange={handleFormChange} />
            )
          case 'radioButton':
            return (
              <RadioButton key={`${field.identifier}${index}`} field={field} index={index} handleFormChange={handleFormChange} />
            )
          case 'file':
              return (
                <DocUpload key={`${field.identifier}${index}`} field={field} index={index} handleFormChange={handleFormChange} />
              )
          case 'otp':
            return (
              <OtpField key={`${field.identifier}${index}`} field={field} index={index} handleFormChange={handleFormChange} />
            )
          case "datePicker":
            return (
              <DatePickerField key={`${field.identifier}${index}`} field={field} index={index} handleFormChange={handleFormChange}/>
            )
          default:
            <div></div>
        }
      })
    } 
    </div>
  );
}

export default FormGroup;
